import {
  chooseNoteStructureModalOutOfProActionsAtom,
  chooseNoteStructureModalTemplateUnavailableAtom,
  chooseNoteStructureModalUnavailableTemplateIdAtom,
  chooseNoteStructureModalUnavailableTemplateWasDefaultAtom,
  isChooseNoteStructureModalDismissibleAtom,
  isChooseNoteStructureModalOpenAtom,
} from '@/atoms/noteStructureAtoms';
import {
  delayUpgradeExtendAction,
  QuotaExceedType,
  shouldShowDelayUpgradeModal,
} from '@/components/modal/delay-upgrade-modal/delayUpgradeAtoms';
import { getDefaultStore } from 'jotai';

const jotaiStore = getDefaultStore();

export function openNoteStructurePicker(): void {
  jotaiStore.set(isChooseNoteStructureModalOpenAtom, () => true);
}

export function reopenNoteStructurePickerForRecovery(): void {
  jotaiStore.set(isChooseNoteStructureModalDismissibleAtom, () => true);
  jotaiStore.set(isChooseNoteStructureModalOpenAtom, () => true);
}

export function openDelayUpgradeModalForStreamQuota(): void {
  jotaiStore.set(shouldShowDelayUpgradeModal, () => true);
  jotaiStore.set(delayUpgradeExtendAction, () => QuotaExceedType.STREAM_NOTE);
}

export function markPickerOutOfProActions(): void {
  jotaiStore.set(chooseNoteStructureModalOutOfProActionsAtom, () => true);
}

/** Preserve the body's eager default decision between the first and second writes. */
export function showPickerUnavailableTemplateBanner(producers: {
  templateId: () => string | null;
  computeWasDefault: () => boolean;
}): void {
  jotaiStore.set(chooseNoteStructureModalUnavailableTemplateIdAtom, producers.templateId);
  const wasDefault = producers.computeWasDefault();
  jotaiStore.set(
    chooseNoteStructureModalUnavailableTemplateWasDefaultAtom,
    () => wasDefault
  );
  jotaiStore.set(chooseNoteStructureModalTemplateUnavailableAtom, () => true);
}
